import { createAsyncThunk } from "@reduxjs/toolkit";
import { DimensionWithCosts } from "@/services/cloudchipr.api";
import { CategoryWithDimensionId } from "@/store/dimensions/utils/types/common";
import { isCategoryWithDimensionId } from "@/components/pages/dimensions/utils/helpers/isCategoryWithDimensionId";
import { updateCategoryByIdThunk } from "@/store/dimensions/thunks/categories/updateCategoryByIdThunk";
import { updateDimensionNameThunk } from "@/store/dimensions/thunks/dimensions/updateDimensionNameThunk";
import { getDimensionsThunk } from "@/store/dimensions/thunks/dimensions/getDimensionsThunk";

export const updateDimensionOrCategoryName = createAsyncThunk(
  "dimensions/updateDimensionOrCategoryName",
  async (data: DimensionWithCosts | CategoryWithDimensionId, { dispatch }) => {
    let response;

    if (isCategoryWithDimensionId(data)) {
      response = await dispatch(
        updateCategoryByIdThunk({
          dimensionId: data.dimensionId,
          name: data.name,
          categoryId: data.id,
          filter: data.filters,
        }),
      ).unwrap();
    } else {
      response = await dispatch(
        updateDimensionNameThunk({ dimensionId: data.id, name: data.name }),
      ).unwrap();
    }

    if (response) {
      dispatch(getDimensionsThunk(true));
    }
  },
);
